import React from "react";
import cn from "classnames";
import styles from "./Attribute.module.sass";
import Card from "../../components/Card";
import Market from "./Market";


const AttributesList = () => {

  return (
    <>
      <Card
        className={styles.card}
        classCardHead={styles.head}
        title="Attributes"
        classTitle={cn("title-green", styles.title)}
      >
        <div className={styles.wrapper}>
          <Market />
        </div>
      </Card>

    </>
  );
};

export default AttributesList;
